function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2402",
  "data-name": "Group 2402",
  transform: "translate(-976 -174)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_383",
  "data-name": "Group 383",
  transform: "translate(164 -146)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_10",
  "data-name": "Ellipse 10",
  cx: 21,
  cy: 21,
  r: 21,
  transform: "translate(812 320)",
  fill: "#eeeff3"
})), /*#__PURE__*/React.createElement("path", {
  id: "mail_FILL1_wght400_GRAD0_opsz48",
  d: "M5.575,25a1.5,1.5,0,0,1-1.1-.478A1.538,1.538,0,0,1,4,23.406V9.594a1.538,1.538,0,0,1,.473-1.116A1.5,1.5,0,0,1,5.575,8h17.85a1.5,1.5,0,0,1,1.1.478A1.538,1.538,0,0,1,25,9.594V23.406a1.538,1.538,0,0,1-.472,1.116,1.5,1.5,0,0,1-1.1.478ZM14.5,16.819a.56.56,0,0,0,.223-.04q.092-.04.2-.093l8.243-5.445a.509.509,0,0,0,.2-.213.65.65,0,0,0,.066-.292.621.621,0,0,0-.3-.545.514.514,0,0,0-.617.013L14.5,15.384,6.52,10.2a.549.549,0,0,0-.63-.027.585.585,0,0,0-.315.531.635.635,0,0,0,.079.305.686.686,0,0,0,.184.226l8.243,5.445q.1.053.2.093A.56.56,0,0,0,14.5,16.819Z",
  transform: "translate(982.524 178.62)",
  fill: "#5351fb"
}));

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.eb4ce4f2.svg";
export { ForwardRef as ReactComponent };